import { isLivekitProvider } from "@circle-react/helpers/liveStreamRoomHelpers";
import { useRoom } from "../useRoom";

interface UseProviderHookProps<T, U> {
  hms: T;
  livekit: U;
}

export const useProviderHook = <T, U>({
  hms,
  livekit,
}: UseProviderHookProps<T, U>): T | U => {
  const room = useRoom();
  if (isLivekitProvider(room)) {
    return livekit;
  }
  // Return HMS by default
  return hms;
};
